import { Div } from "../../../../base/components/native/div"
import { loadingStyle } from "./loading.style"

export const Loading = () => {
    const base = Div('در حال دریافت اطلاعات...')
    base.style(loadingStyle)

    return base
}
